import * as React from "react";
import {Button, SpaceBetween} from "@amzn/awsui-components-react-v3";
import Box from "@amzn/awsui-components-react-v3/polaris/box";

interface TableEmptyStateProps {
    resourceName: string
}
interface TableNoMatchStateProps {
    onClearFilter: () => void
}
export const TableEmptyState = (props: TableEmptyStateProps ) => (
    <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
        <SpaceBetween size="xxs">
            <div>
                <b>No {props.resourceName}</b>
                <Box variant="p" color="inherit">
                    No {props.resourceName} associated with this resource.
                </Box>
            </div>
        </SpaceBetween>
    </Box>
);
export const TableNoMatchState = (props: TableNoMatchStateProps) => (
    <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
        <SpaceBetween size="xxs">
            <div>
                <b>No matches</b>
                <Box variant="p" color="inherit">
                    We can't find a match.
                </Box>
            </div>
            <Button onClick={props.onClearFilter}>Clear filter</Button>
        </SpaceBetween>
    </Box>
);